var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenedEnvelopeSubtitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14204_55273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V6",
    stroke: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6L9.16248 10.1697C8.46708 10.6664 7.53292 10.6664 6.83752 10.1697L1 6",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6L9.16248 1.83034C8.46708 1.33363 7.53292 1.33363 6.83752 1.83034L1 6",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14L9.4 10M1 14L6.6 10",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14204_55273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedEnvelopeSubtitle);
export default __webpack_public_path__ + "static/media/opened-envelope-subtitle.1e4ec7fcec4bc309a441fe795122ac3b.svg";
export { ForwardRef as ReactComponent };